<template>
  <avs-chip
    class="min-width-120"
    color="warning"
    icon="mdi-timer-sand-complete"
    iconColor="black"
    text-color="black"
  >
    {{ $t("commons.status.pending") }}
  </avs-chip>
</template>

<script>
export default {
  name: "PendingChip",
};
</script>
